import React from 'react';
import SvgIconContainer from '../SvgIconContainer';

export default function IconAdd(props) {
  return (
    <SvgIconContainer {...props}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 12 12"
        fill="currentColor"
        fillRule="nonzero"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12.1989 7.19348H7.06458V12.3279H5.35312V7.19348H0.21875V5.48203H5.35312V0.347656H7.06458V5.48203H12.1989V7.19348Z" />
      </svg>
    </SvgIconContainer>
  );
}

IconAdd.propTypes = SvgIconContainer.propTypes;
